const atomic = require('../../../git_modules/@tomandco/atomic/config/typography');

/**
 * Font families used to generate atomic classes.
 *
 * WARNING!!! `key` and `value` are required.
 * Other are used in iCMS
 *
 * @example
 * ```css
 *   .font-1 { font-family: "'Lato', sans-serif"; }
 * ```
 */
const fontFamily = [
    // default atomic
    ...atomic.fontFamily,
    // custom local
    { key: '1', value: "'source-sans-3', sans-serif", title: 'Source Sans 3', styles: ['normal', 'italic'] },
    { key: '2', value: "'baskerville-urw', sans-serif", title: 'Baskerville URW', fw: ['fw-regular'], styles: ['normal'] }
];
exports.fontFamily = fontFamily;

const fontWeight = [
    // default atomic
    // ...atomic.fontWeight,
    // custom local
    { key: 'regular', value: '400', title: 'Regular' },
    { key: 'semibold', value: '600', title: 'Semibold' },
    { key: 'bold', value: '700', title: 'Bold' }
];
exports.fontWeight = fontWeight;

const fontStyle = [
    { key: 'normal', value: 'normal', title: 'Normal' },
    { key: 'italic', value: 'italic', title: 'Italic' }
];
exports.fontStyle = fontStyle;

const textStyle = [
    { key: 'hero', title: 'Hero' },
    { key: 'h1', title: 'Heading 1' },
    { key: 'h2', title: 'Heading 2' },
    { key: 'h3', title: 'Heading 3' },
    { key: 'h4', title: 'Heading 4' },
    { key: 'h5', title: 'Heading 5' },
    { key: 's1', title: 'Sub-heading 1' },
    { key: 's2', title: 'Sub-heading 2' },
    { key: 'p1', title: 'Paragraph 1' },
    { key: 'p2', title: 'Paragraph 2' },
    { key: 'p3', title: 'Paragraph 3' },
    { key: 'o1', title: 'Overline 1' },
    { key: 'c1', title: 'Caption 1' }
];
exports.textStyle = textStyle;
